import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class PlasticityIndexIpCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (PlasticityIndexIpCalculationMethodModel._instance == null) PlasticityIndexIpCalculationMethodModel._instance = new PlasticityIndexIpCalculationMethodModel(authManager);
        return PlasticityIndexIpCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/plasticity-index-ip-calculation-methods', 'geo-sections/plasticity-index-ip-calculation-methods/codelist');

        this.entityName = 'geo-sections.PlasticityIndexIpCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Plasticity Index Ip Calc Method';
        this.setLabel = 'Plasticity Index Ip Calc Methods';

        this.browser = {
            name: 'default-geo-sections-plasticityindexipcalculationmethod-browser',
            moduleName: 'default-geo-sections-plasticityindexipcalculationmethod-browser',
            moduleTitle: 'Plasticity Index Ip Calc Methods',
            moduleStateSlotName: 'default-geo-sections-plasticityindexipcalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-plasticityindexipcalculationmethod-editor',
            moduleName: 'default-geo-sections-plasticityindexipcalculationmethod-editor',
            moduleTitle: 'Plasticity Index Ip Calc Method',
            moduleStateSlotName: 'default-geo-sections-plasticityindexipcalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
